import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";
import { useCurrency } from "@/context/CurrencyContext";

export default function Shop() {
  const { format } = useCurrency();
  const { t } = useTranslation();
  const [products, setProducts] = useState([]);
  const [cat, setCat] = useState("all");
  useEffect(() => { api.get("/products").then((r) => setProducts(r.data.filter((p) => p.category !== "bundle"))); }, []);
  const filtered = cat === "all" ? products : products.filter((p) => p.category === cat);
  return (
    <div className="text-white max-w-7xl mx-auto px-6 md:px-10 py-16">
      <p className="uppercase text-xs tracking-[0.3em] text-[#00B5D8] mb-3">Shop</p>
      <h1 className="font-display text-5xl md:text-6xl mb-8">Complete your Preshh GO.</h1>
      <div className="flex gap-2 mb-10 flex-wrap">
        {["all", "kit", "accessory"].map((c) => (
          <button key={c} data-testid={`shop-filter-${c}`} onClick={() => setCat(c)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${cat === c ? "bg-[#00B5D8] text-black" : "bg-white/5 hover:bg-white/10 text-white"}`}>
            {c === "all" ? "All" : c.charAt(0).toUpperCase() + c.slice(1) + "s"}
          </button>
        ))}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
        {filtered.map((p) => (
          <Link key={p.id} data-testid={`shop-product-card-${p.slug}`} to={`/product/${p.slug}`} className="group">
            <div className="aspect-square rounded-2xl overflow-hidden bg-[#111] border border-white/10">
              <img src={p.images[0]} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <p className="mt-4 font-semibold">{p.name}</p>
            {p.tagline && <p className="text-sm text-white/50">{p.tagline}</p>}
            <p className="text-[#00B5D8] mt-1 font-display text-lg">{format(p.price)} <span className="text-white/50 text-xs font-sans font-normal">{t("vat_suffix")}</span></p>
          </Link>
        ))}
      </div>
    </div>
  );
}
